import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { messages } from "../../constants/commonMessages";
import moment from "moment";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import "./dashboardTable.scss";
import Label from "../../components/Label/Label";
import PriorityHighIcon from "@mui/icons-material/ReportProblem";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as acts from "../../redux/processor/actions";
import * as act from "../../redux/pre_processor/actions";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DraftIcon from "../../assets/svg/draft-svgrepo-com.svg";
import CloneModal from "../Modal/ClonModal/CloneModal";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CircularProgressWithLabel from "./../CircularProgressBar";

import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { action } from "../../constants/action";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import InfoModal from "../../components/Modal/InfoModal/InfoModal";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import UploadFileSharpIcon from "@mui/icons-material/UploadFileSharp";
import { preProRoutes, proRoutes } from "../../routes/routeConstants";
import constantValues from "../../constants/constantValues";

function Row(props) {
  const { i } = props;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  const [menus, setMenus] = useState([]);
  const [menus2, setMenus2] = useState([]);

  const [list, setList] = useState();
  const MyOptions = [
    "Edit",
    "Assign Processor",
    "Upload PDF",
    "Extract",
    "Validate",
    "Reinitiate auto extraction",
    "View",
  ];
  const openpop = Boolean(anchorE2);
  const navigate = useNavigate();
  const [clone, setClone] = useState(false);
  const infoData = useSelector((state) => state?.pro?.infoData);
  const [infoModal, setInfoModal] = useState(false);
  const handleClick = (index) => (event) => {
    const updatedMenus = [...menus];
    updatedMenus[index] = true;
    // menus[index] = true;
    setAnchorEl(event.currentTarget);
    setMenus(updatedMenus);
  };
  const handleClose = (index) => () => {
    // menus[index] = false;
    const updatedMenus = [...menus];
    updatedMenus[index] = false;
    setAnchorEl(null);
    setMenus(updatedMenus);
  };

  const onCreacteNewBatch = (projectId, key) => {
    localStorage.setItem(messages.PROJECT_ID, projectId);
    localStorage.setItem("projectName", row.project_name);
    localStorage.setItem("projectId", row.project_id);
    localStorage.setItem("drugType", row.drug_type);
    localStorage.setItem("projectType", row?.project_type);
    navigate(
      key === "single"
        ? `/${preProRoutes.newBatch}`
        : `/${preProRoutes.createMultipleBatches}`,
    );
  };
  const onClone = (projectId) => {
    setClone(true);
    localStorage.setItem(messages.PROJECT_ID, projectId);
    localStorage.setItem("projectName", row.project_name);
    // localStorage.setItem("projectId", row.project_id);
  };

  const onAddNewPdfs = (projectId) => {
    localStorage.setItem(messages.PROJECT_ID, projectId);
    localStorage.setItem("projectName", row.project_name);
    localStorage.setItem("drugType", row.drug_type);
    navigate(`/${preProRoutes.uploadBatchRecord}`, {
      state: { supplementaryPdf: true },
    });
  };
  const onCloseClone = () => {
    setClone(false);
  };
  const dispatch = useDispatch();
  const handleProjectClick = (row) => {
    const { project_name, project_id } = row;
    localStorage.setItem("projectName", project_name);
    localStorage.setItem("projectId", project_id);
    localStorage.setItem("drugType", row.drug_type);
    // localStorage.setItem("mapData", row.is_map_data);
    localStorage.setItem("isCloned", row.is_cloned);
    localStorage.setItem("projectType", row?.project_type);
    localStorage.setItem("qc_mapping_status", row.qc_mapping_status);
    localStorage.setItem(
      "template_mapping_status",
      row.template_mapping_status,
    );
    localStorage.setItem("mappingOption", "project"); // if (row?.project_type === "qc_extraction") {
    localStorage.removeItem("isReadonlyBatchMappings");

    // if (row?.project_type === "free_form") {
    //   localStorage.setItem("qc_mapping_status", row.qc_mapping_status);
    // } else if (row?.project_type === "template_driven") {
    //   localStorage.setItem(
    //     "template_mapping_status",
    //     row.template_mapping_status
    //   );
    // } else if (row?.project_type === "both") {
    //   localStorage.setItem("qc_mapping_status", row.qc_mapping_status);
    //   localStorage.setItem(
    //     "template_mapping_status",
    //     row.template_mapping_status
    //   );
    // }
    //Redirect to Diff Pages based on activities performed by user on project.
    if (row.template_n_op_step_done) {
      navigate(`/${preProRoutes.mapData}`);

      return;
    }
    if (!row.is_pdf_uploaded) {
      navigate(`/${preProRoutes.uploadBatchRecord}`);
      return;
    }
    if (!row.is_template_upload) {
      navigate(`/${preProRoutes.uploadTemplateData}`);
      return;
    }
    if (row.template_n_op_step_done) {
      navigate(`/${preProRoutes.mapData}`);
      return;
    }
    navigate(`/${preProRoutes.mapData}`);
  };
  //-----------------------------new-------------------------------------

  useEffect(() => {
    localStorage.setItem("count", 0);
  }, []);
  const handleClickOption = (e, list, index) => {
    setList(list);
    setAnchorE2(e.currentTarget);
    // menus2[index] = true;
    const updatedMenus2 = [...menus2];
    updatedMenus2[index] = true;
    setMenus2(updatedMenus2);
  };

  const handleClickOnOption = (option) => {
    if (localStorage.getItem("userRole") === "validator") {
      if (option === "Validate") {
        localStorage.setItem("batchId", list.batch_id);
        localStorage.setItem("projectName", row.project_name);
        localStorage.setItem("batchName", list.batch_name);
        localStorage.setItem("projectId", row.project_id);
        localStorage.setItem("drugType", row.drug_type);
        localStorage.setItem("batch_for_qc", list.batch_for_qc);

        if (list.is_validator_view === false) {
          dispatch(acts.isProcessView(list.batch_id));
        }
        navigate(`/data-validation`);
      }
    } else if (localStorage.getItem("userRole") === "processor") {
      if (option === "Extract") {
        localStorage.setItem("projectId", row.project_id);
        localStorage.setItem("projectName", row.project_name);
        localStorage.setItem("batchName", list.batch_name);
        localStorage.setItem("batchId", list.batch_id);
        localStorage.setItem("drugType", row.drug_type);
        // localStorage.setItem(
        //   "batch_extraction_type",
        //   list.batch_extraction_type
        // );
        localStorage.setItem("batch_for_qc", list.batch_for_qc);

        if (list.is_processor_view === false) {
          dispatch(acts.isProcessView(list.batch_id));
        }
        navigate(`/${proRoutes.dataEntry}`);
      }
    } else if (localStorage.getItem("userRole") === "pre-processor") {
      if (option === "Edit") {
        localStorage.setItem("projectId", row.project_id);
        localStorage.setItem("projectName", row.project_name);
        localStorage.setItem("batchName", list.batch_name);
        localStorage.setItem("batchId", list.batch_id);
        localStorage.setItem("drugType", row.drug_type);
        localStorage.setItem("mappingOption", "batch");
        localStorage.setItem("projectType", row?.project_type);

        // localStorage.setItem(
        //   "batch_extraction_type",
        //   list.batch_extraction_type
        // );
        localStorage.setItem("batch_for_qc", list.batch_for_qc);
        localStorage.setItem("isReadonlyBatchMappings", false);

        navigate(`/${preProRoutes.mapData}`);
      }

      if (option === "Upload PDF") {
        localStorage.setItem("projectName", row.project_name);
        localStorage.setItem("projectId", row.project_id);
        localStorage.setItem("batchName", list.batch_name);
        localStorage.setItem("batchId", list.batch_id);
        localStorage.setItem("drugType", row.drug_type);

        // localStorage.setItem("ocrReInitiate", list?.ocr_re_initiate);
        // if (list?.is_pdf_uploaded && list?.ocr_re_initiate) {
        //   history.push("/upload-pdf-against-batch");
        // } else if (list?.is_pdf_uploaded) {
        //   history.push("/prepro-user-permission");
        // } else {
        navigate(`/${preProRoutes.uploadPdfAgainstBatch}`);
        // }
      }
      if (option === "Assign Processor") {
        localStorage.setItem("projectName", row.project_name);
        localStorage.setItem("projectId", row.project_id);
        localStorage.setItem("batchName", list.batch_name);
        localStorage.setItem("batchId", list.batch_id);
        localStorage.setItem("drugType", row.drug_type);

        localStorage.setItem("mappingOption", "batch");
        localStorage.setItem("projectType", row?.project_type);

        // localStorage.setItem("ocrReInitiate", list?.ocr_re_initiate);
        // if (list?.is_pdf_uploaded && list?.ocr_re_initiate) {
        //   history.push("/upload-pdf-against-batch");
        // } else if (list?.is_pdf_uploaded) {
        navigate(`/${preProRoutes.preProUserPermission}`);
        // } else {
        //   history.push("/upload-pdf-against-batch");
        // }
      }

      if (option === "View") {
        localStorage.setItem("projectId", row.project_id);
        localStorage.setItem("projectName", row.project_name);
        localStorage.setItem("batchName", list.batch_name);
        localStorage.setItem("batchId", list.batch_id);
        localStorage.setItem("drugType", row.drug_type);
        localStorage.setItem("mappingOption", "batch");
        localStorage.setItem("projectType", row?.project_type);

        // localStorage.setItem(
        //   "batch_extraction_type",
        //   list.batch_extraction_type
        // );
        localStorage.setItem("batch_for_qc", list.batch_for_qc);
        localStorage.setItem("isReadonlyBatchMappings", true);

        navigate(`/${preProRoutes.mapData}`);
      }

      if (option === "Reinitiate auto extraction") {
        dispatch(act.handleOcrReinitiate(list.batch_id));
      }
    }
  };
  const handleData = (data) => {};
  const handleClosePopUp = (index) => {
    setAnchorE2(null);
    menus2[index] = false;
  };
  const InfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#e8e7e7",
      whiteSpace: "normal",
      wordBreak: "break-word",
      display: "inline-block",
      maxWidth: "90vw",
      padding: "12px",
    },
  }));

  const { row } = props;
  // const handleReinitiateOcr = (id) => {
  //   dispatch(act.handleOcrReinitiate(id));
  // };

  const isDisabledEditIcon = (list) => {
    if (list?.batch_for_qc) {
      if (list?.is_ocr_done === "pending" && list?.is_failed === false) {
        return true;
      } else if (list?.batch_for_qc === true && list?.rejected_by_validator) {
        return false;
      } else if (
        list?.validation_skipped === false &&
        list?.is_validator_assigned === false
      ) {
        return false;
      } else return true;
    } else if (list?.is_validator_assigned === false) {
      return false;
    } else return true;
  };
  return (
    <>
      <TableRow className="row-wrap">
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell component="td" scope="row">
          {row?.new_batch && <FiberNewOutlinedIcon className="new-icon" />}
          {row?.total_rejected_batches > 0 && (
            // ||
            //   row.mapping_review_status === "rejected"
            <PriorityHighIcon
              color="warning"
              className="priority-reject-icon"
            ></PriorityHighIcon>
          )}
          {localStorage.getItem("userRole") === "pre-processor" && (
            <InfoTooltip
              title={
                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  <Box className="tool-tip-typo">
                    <Typography className="tooltip-text-head">
                      PDF Name
                    </Typography>

                    {/* {row?.pdfs?.map((pdf, idx) => (
                      <Typography className="tooltip-text" key={idx}>
                        {pdf.replaceAll(",", ", ") +
                          (idx !== row.pdfs.length - 1 ? "," : "")}
                      </Typography>
                    ))} */}
                    {row?.pdfs?.map((pdf, idx) => (
                      <Typography className="tooltip-text" key={idx}>
                        {pdf.replaceAll(",", ", ") +
                          (idx !== row.pdfs.length - 1 ? "," : "")}
                      </Typography>
                    ))}
                  </Box>
                  <Box className="tool-tip-typo">
                    <Typography className="tooltip-text-head">
                      Template
                    </Typography>

                    {(row.project_type === "template_driven" ||
                      row.project_type === "both") && (
                      <Typography className="tooltip-text">{`AE - ${
                        row?.template_name || ""
                      }`}</Typography>
                    )}

                    {(row.project_type === "free_form" ||
                      row.project_type === "both") && (
                      <Typography className="tooltip-text">{`QC - ${
                        row?.qc_template_name || ""
                      }`}</Typography>
                    )}
                  </Box>
                  {(row.project_type === "template_driven" ||
                    row.project_type === "both") && (
                    <Box className="tool-tip-typo">
                      <Typography className="tooltip-text-head">
                        Output Format
                      </Typography>
                      <Typography className="tooltip-text">{`AE - ${
                        row?.op_format_name || ""
                      }`}</Typography>
                    </Box>
                  )}
                </Box>
              }
              arrow
              placement="right"
              sx={{
                "& .MuiTooltip-arrow": {},
              }}
            >
              <InfoIcon color="action"></InfoIcon>
            </InfoTooltip>
          )}

          <div className="p-name">
            <div>{row.project_name} </div>

            <Stack direction="row" className="drugType-wrap">
              <Chip
                label={row.drug_type}
                // size="small"
                className="drugType"
              />

              <Label
                fontSize={12}
                fontWeight={500}
                text={`${
                  row.project_type === "both"
                    ? "QC & AE"
                    : row.project_type === "template_driven"
                      ? "AE"
                      : row.project_type === "free_form"
                        ? "QC"
                        : ""
                }`}
                padding={"0px 0px 0px 5px"}
              />
            </Stack>
          </div>
        </TableCell>
        <TableCell></TableCell>
        {localStorage.getItem("userRole") === "pre-processor" && (
          <TableCell>
            {row?.total_batches} , {row?.total_rejected_batches}{" "}
          </TableCell>
        )}
        {localStorage.getItem("userRole") === "processor" && (
          <TableCell color="#1239ff">
            {row?.total_batches} , {row?.total_rejected_batches}
          </TableCell>
        )}
        {localStorage.getItem("userRole") === "validator" && (
          <TableCell color="#1239ff">
            {row?.total_batches} , {row?.total_rejected_batches}
          </TableCell>
        )}

        {localStorage.getItem("userRole") === "pre-processor" &&
          row?.total_pdfs >= 0 && <TableCell>{row?.total_pdfs}</TableCell>}

        {localStorage.getItem("userRole") === "pre-processor" && (
          <>
            <TableCell>
              {row?.mapping_reviewer_name
                ? row?.mapping_reviewer_name
                : "Unassigned"}
            </TableCell>
            <TableCell>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 2, // space between icon and text
                }}
              >
                {row?.mapping_review_status === "rejected" && (
                  <Tooltip
                    title={`Rejection Remark: ${
                      row?.mapping_review_status && row?.mapping_reviewer_remark
                        ? row.mapping_reviewer_remark
                        : "Rejected"
                    }`}
                  >
                    <PriorityHighIcon color="warning" fontSize="small" />
                  </Tooltip>
                )}
                <span>
                  {row?.mapping_review_status?.replace(/_/g, " ")}
                </span>{" "}
              </div>
            </TableCell>
            <TableCell>{""}</TableCell>
          </>
        )}

        {localStorage.getItem("userRole") === "validator" && (
          <>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </>
        )}

        {localStorage.getItem("userRole") === "processor" ? (
          <>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </>
        ) : (
          ""
        )}

        <TableCell>
          {moment(row.updated_on, "DD-MMM-YYYY HH:mm:ss").format("DD-MMM-YYYY")}
          <br />
          {moment(row.updated_on, "DD-MMM-YYYY HH:mm:ss").format("hh:mm:ss A")}
        </TableCell>
        {localStorage.getItem("userRole") === "processor" && (
          <TableCell>
            <InfoTooltip
              title={
                <Box>
                  <Box className="tool-tip-typo">
                    <Typography className="tooltip-text-head">
                      PDF Name
                    </Typography>

                    {/* {row?.pdfs?.map((index) => (
                      <Typography className="tooltip-text">{`${index.replaceAll(
                        ",",
                        ", "
                      )},`}</Typography>
                    ))} */}

                    {row?.pdfs?.map((pdf, idx) => (
                      <Typography className="tooltip-text" key={idx}>
                        {pdf.replaceAll(",", ", ") +
                          (idx !== row.pdfs.length - 1 ? "," : "")}
                      </Typography>
                    ))}
                  </Box>
                  <Box className="tool-tip-typo">
                    <Typography className="tooltip-text-head">
                      Template
                    </Typography>

                    {(row.project_type === "template_driven" ||
                      row.project_type === "both") && (
                      <Typography className="tooltip-text">{`AE - ${
                        row?.template_name || ""
                      }`}</Typography>
                    )}

                    {(row.project_type === "free_form" ||
                      row.project_type === "both") && (
                      <Typography className="tooltip-text">{`QC - ${
                        row?.qc_template_name || ""
                      }`}</Typography>
                    )}
                  </Box>
                  {(row.project_type === "template_driven" ||
                    row.project_type === "both") && (
                    <Box className="tool-tip-typo">
                      <Typography className="tooltip-text-head">
                        Output Format
                      </Typography>
                      <Typography className="tooltip-text">{`AE - ${
                        row?.op_format_name || ""
                      }`}</Typography>
                    </Box>
                  )}
                </Box>
              }
              arrow
              placement="right"
              sx={{
                "& .MuiTooltip-arrow": {},
              }}
            >
              <InfoIcon color="action"></InfoIcon>
            </InfoTooltip>
          </TableCell>
        )}
        {localStorage.getItem("userRole") === "validator" && (
          <TableCell>
            <InfoTooltip
              title={
                <Box>
                  <Box className="tool-tip-typo">
                    <Typography className="tooltip-text-head">
                      PDF Name
                    </Typography>

                    {/* {row?.pdfs?.map((index) => (
                      <Typography className="tooltip-text">{`${index.replaceAll(
                        ",",
                        ", "
                      )},`}</Typography>
                    ))} */}
                    {row?.pdfs?.map((pdf, idx) => (
                      <Typography className="tooltip-text" key={idx}>
                        {pdf.replaceAll(",", ", ") +
                          (idx !== row.pdfs.length - 1 ? "," : "")}
                      </Typography>
                    ))}
                  </Box>
                  <Box className="tool-tip-typo">
                    <Typography className="tooltip-text-head">
                      Template
                    </Typography>

                    {(row.project_type === "template_driven" ||
                      row.project_type === "both") && (
                      <Typography className="tooltip-text">{`AE - ${
                        row?.template_name || ""
                      }`}</Typography>
                    )}

                    {(row.project_type === "free_form" ||
                      row.project_type === "both") && (
                      <Typography className="tooltip-text">{`QC - ${
                        row?.qc_template_name || ""
                      }`}</Typography>
                    )}
                  </Box>
                  {(row.project_type === "template_driven" ||
                    row.project_type === "both") && (
                    <Box className="tool-tip-typo">
                      <Typography className="tooltip-text-head">
                        Output Format
                      </Typography>
                      <Typography className="tooltip-text">{`AE - ${
                        row?.op_format_name || ""
                      }`}</Typography>
                    </Box>
                  )}
                </Box>
              }
              arrow
              placement="right"
              sx={{
                "& .MuiTooltip-arrow": {},
              }}
            >
              <InfoIcon color="action"></InfoIcon>
            </InfoTooltip>
          </TableCell>
        )}
        {localStorage.getItem("userRole") === "pre-processor" ? (
          <TableCell>
            <IconButton
              aria-owns={anchorEl ? `simple-menu-${i}` : null}
              aria-haspopup="true"
              onClick={handleClick(i)}
              disabled={
                !row?.rejected_by_processor && row.is_role_grant === true
                  ? true
                  : false
              }
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              className="action-list"
              id={`simple-menu-${i}`}
              anchorEl={anchorEl}
              // keepMounted
              open={menus[i] === true}
              onClose={handleClose(i)}
            >
              <MenuItem
                className="action-item"
                onClick={() => handleProjectClick(row)}
                disabled={
                  row?.mapping_review_status === "assigned" ||
                  row?.mapping_review_status === "under_review"
                    ? true
                    : false
                }
              >
                <EditTwoToneIcon /> {action.EDIT}
              </MenuItem>

              {row?.project_type === "free_form" &&
                row?.qc_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() => onCreacteNewBatch(row?.project_id, "single")}
                  >
                    <AddIcon /> {action.ADD_NEW_BATCHES}
                  </MenuItem>
                )}

              {row?.project_type === "template_driven" &&
                row?.template_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    disabled={
                      !["approved", "not_applicable"].includes(
                        row?.mapping_review_status,
                      )
                    }
                    // disabled={
                    //   row?.mapping_review_status !== "approved"
                    //   // ||
                    //   // row?.mapping_review_status !== "rejected"
                    // }
                    onClick={() => onCreacteNewBatch(row?.project_id, "single")}
                  >
                    <AddIcon /> {action.ADD_NEW_BATCHES}
                  </MenuItem>
                )}

              {row?.project_type === "both" &&
                row?.qc_mapping_status === "done" &&
                row?.template_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() => onCreacteNewBatch(row?.project_id, "single")}
                  >
                    <AddIcon /> {action.ADD_NEW_BATCHES}
                  </MenuItem>
                )}

              {/* {row?.template_mapping_status === "done" &&
                row?.total_pdfs === 1 &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() =>
                      onCreacteNewBatch(row?.project_id, "multiple")
                    }
                  >
                    <QueueTwoToneIcon /> {action.CREATE_MULTIPLE_BATCH}
                  </MenuItem>
                )} */}
              {row?.project_type === "free_form" &&
                row?.qc_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() => onClone(row?.project_id)}
                  >
                    <FileCopyIcon />
                    Clone Project
                  </MenuItem>
                )}

              {row?.project_type === "template_driven" &&
                row?.template_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    disabled={
                      row?.mapping_review_status !== "approved"
                      // ||
                      // row?.mapping_review_status !== "rejected"
                    }
                    onClick={() => onClone(row?.project_id)}
                  >
                    <FileCopyIcon />
                    Clone Project
                  </MenuItem>
                )}

              {row?.project_type === "both" &&
                row?.qc_mapping_status === "done" &&
                row?.template_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    disabled={
                      row?.mapping_review_status !== "approved"
                      // ||
                      // row?.mapping_review_status !== "rejected"
                    }
                    onClick={() => onClone(row?.project_id)}
                  >
                    <FileCopyIcon />
                    Clone Project
                  </MenuItem>
                )}

              {row?.project_type === "free_form" &&
                row?.qc_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() => onAddNewPdfs(row?.project_id)}
                  >
                    <UploadFileSharpIcon />
                    Add Additional Files
                  </MenuItem>
                )}

              {row?.project_type === "template_driven" &&
                row?.template_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() => onAddNewPdfs(row?.project_id)}
                  >
                    <UploadFileSharpIcon />
                    Add Additional Files
                  </MenuItem>
                )}

              {row?.project_type === "both" &&
                row?.qc_mapping_status === "done" &&
                row?.template_mapping_status === "done" &&
                row?.total_rejected_batches === 0 && (
                  <MenuItem
                    className="action-item"
                    onClick={() => onAddNewPdfs(row?.project_id)}
                  >
                    <UploadFileSharpIcon />
                    Add Additional Files
                  </MenuItem>
                )}
            </Menu>
          </TableCell>
        ) : (
          ""
        )}
      </TableRow>

      {open &&
        row?.batch_info?.map((list, listindex) => (
          <React.Fragment key={list?.id || listindex}>
            <TableRow className="hidden-row" key={list?.id}>
              <TableCell></TableCell>
              {localStorage.getItem("userRole") === "pre-processor" && (
                <TableCell className="float-right">
                  {list?.rejected_by_processor === false &&
                    list?.is_processor_assigned === false && (
                      <FiberNewOutlinedIcon className="new-icon" />
                    )}
                  {/* <Label
                    text={
                      list?.rejected_by_processor === true ? (
                        <PriorityHighIcon color="warning"></PriorityHighIcon>
                      ) : (
                        ""
                      )
                    }
                    color="#1239ff"
                  /> */}
                </TableCell>
              )}
              {localStorage.getItem("userRole") === "processor" && (
                <TableCell className="float-right">
                  <Label
                    isComponentToShow={true}
                    text={
                      list?.is_processor_view !== true ? (
                        <IconButton>
                          <FiberNewOutlinedIcon className="new-icon-batch" />
                        </IconButton>
                      ) : (
                        ""
                      )
                      // ||
                      //   list?.rejected_by_validator ||
                      //   list?.rejected_by_administrator ? (
                      //   <PriorityHighIcon color="warning"></PriorityHighIcon>
                      // ) : (
                      //   ""
                      // )
                    }
                    color="#1239ff"
                  />
                </TableCell>
              )}
              {localStorage.getItem("userRole") === "validator" && (
                <TableCell className="float-right">
                  <Label
                    isComponentToShow={true}
                    text={
                      list?.is_validator_view !== true ? (
                        <IconButton>
                          <FiberNewOutlinedIcon className="new-icon-batch" />
                        </IconButton>
                      ) : (
                        ""
                      )
                    }
                    color="#1239ff"
                  />
                </TableCell>
              )}
              <TableCell className="tooltip-container">
                <Typography className="tool-title">
                  <InfoTooltip
                    title={
                      <Box>
                        <Box className="tool-tip-typo">
                          <Typography className="tooltip-text-head">
                            PDF Name
                          </Typography>

                          {/* {list?.batch_pdfs?.map((index) => (
                            <Typography className="tooltip-text">{`${index.replaceAll(
                              ",",
                              ", "
                            )},`}</Typography>
                          ))} */}
                          {list?.batch_pdfs?.map((pdf, idx) => (
                            <Typography className="tooltip-text" key={idx}>
                              {pdf.replaceAll(",", ", ") +
                                (idx !== row.pdfs.length - 1 ? "," : "")}
                            </Typography>
                          ))}
                        </Box>
                        {localStorage.getItem("userRole") === "processor" && (
                          <Box className="tool-tip-typo">
                            <Typography className="tooltip-text-head">
                              Pre Processor
                            </Typography>
                            <Typography className="tooltip-text">
                              {" "}
                              {`${list?.pre_processor_name}`}
                            </Typography>
                          </Box>
                        )}
                        {localStorage.getItem("userRole") === "validator" && (
                          <Box>
                            <Box className="tool-tip-typo">
                              <Typography className="tooltip-text-head">
                                Processor
                              </Typography>
                              <Typography className="tooltip-text">
                                {list?.processor_name}
                              </Typography>
                            </Box>
                            <Box className="tool-tip-typo">
                              <Typography className="tooltip-text-head">
                                Pre Processor
                              </Typography>
                              <Typography className="tooltip-text">
                                {" "}
                                {list?.pre_processor_name}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    }
                    arrow
                    placement="left"
                    sx={{
                      "& .MuiTooltip-arrow": {},
                    }}
                  >
                    <InfoIcon color="action"></InfoIcon>
                  </InfoTooltip>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ marginLeft: "10px" }}>
                      {list?.batch_name}
                    </Typography>

                    <Chip
                      label={
                        list?.batch_for_qc === true
                          ? "Quality Control"
                          : "Auto Extraction"
                      }
                      // size="small"
                      className="extraction-type"
                    />
                  </div>
                </Typography>
              </TableCell>
              <TableCell> </TableCell>
              {localStorage.getItem("userRole") === "pre-processor" && (
                <>
                  {list?.total_pdfs <= 1 && (
                    <TableCell>{list?.total_pdfs}</TableCell>
                  )}
                  {list?.total_pdfs > 1 && (
                    <TableCell>{list?.total_pdfs}</TableCell>
                  )}
                </>
              )}

              {localStorage.getItem("userRole") === "pre-processor" && (
                <>
                  {(list?.rejected_by_processor || list.ocr_re_initiate) && (
                    <TableCell>
                      <Tooltip
                        title={
                          "Rejection Remark:" +
                          (list?.processor_rejection_remark
                            ? list?.processor_rejection_remark
                            : "Rejected")
                        }
                      >
                        <PriorityHighIcon color="warning"></PriorityHighIcon>
                      </Tooltip>
                    </TableCell>
                  )}
                  {list?.rejected_by_processor === false &&
                    !list.ocr_re_initiate && (
                      <TableCell className="assigned-status">
                        {" "}
                        {list?.is_processor_assigned ? (
                          ""
                        ) : (
                          <Tooltip title="[Draft]">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img className="img" src={DraftIcon} alt="" />
                              <span style={{ marginLeft: "5px" }}>Draft</span>
                            </div>
                          </Tooltip>
                        )}{" "}
                        {list?.processor}
                      </TableCell>
                    )}

                  <TableCell className="assigned-status"></TableCell>
                  {list?.is_ocr_done === "pending" && (
                    <TableCell className="text-center">
                      <Tooltip
                        title={
                          list?.is_failed === true
                            ? "Extraction Failed"
                            : `Progress: ${list?.completion_status}`
                        }
                      >
                        {/* <div style={{ width: "100px" }}> */}
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-flex",
                          }}
                        >
                          {list?.completion_status === "100%" ? (
                            <DoneAllIcon color="primary" />
                          ) : list?.is_failed === true ? (
                            <RunningWithErrorsIcon />
                          ) : (
                            <CircularProgressWithLabel
                              value={list?.completion_status}
                            />
                          )}
                        </Box>
                        {/* </div> */}
                      </Tooltip>
                    </TableCell>
                  )}
                  {list?.is_ocr_done === "done" && (
                    <TableCell className="text-center">
                      <Tooltip title="Done">
                        <DoneAllIcon color="primary" />
                      </Tooltip>
                    </TableCell>
                  )}
                  {list?.is_ocr_done === "not_started" && (
                    <TableCell className="text-center">
                      <Tooltip title="Not Started">
                        <img className="img" src={DraftIcon} alt="" />
                      </Tooltip>
                    </TableCell>
                  )}
                </>
              )}
              {localStorage.getItem("userRole") === "processor" && (
                <>
                  <TableCell>{list?.data_entry_end_date}</TableCell>
                  <TableCell>
                    {list?.rejected_by_validator ||
                    (list?.rejected_by_administrator &&
                      list?.is_validator_assigned === false) ? (
                      <Tooltip
                        title={
                          "Rejection Remark:" +
                          (list?.rejected_by_validator &&
                          list?.validator_rejection_remark
                            ? list?.validator_rejection_remark
                            : list?.rejected_by_administrator &&
                                list?.administrator_rejection_remark
                              ? list?.administrator_rejection_remark
                              : "Rejected")
                        }
                      >
                        <PriorityHighIcon color="warning"></PriorityHighIcon>
                      </Tooltip>
                    ) : (
                      list?.rejected_by_validator === false &&
                      (list?.rejected_by_administrator === false ||
                        list?.is_validator_assigned) &&
                      (list?.is_validator_assigned ? (
                        list?.validator
                      ) : (
                        <>
                          {list?.batch_for_qc === true &&
                          list?.validation_skipped === true ? (
                            constantValues.ADMIN
                          ) : (
                            <Tooltip title="[Draft]">
                              <img
                                className="img"
                                src={DraftIcon}
                                alt="Draft"
                              />
                            </Tooltip>
                          )}
                        </>
                      ))
                    )}
                  </TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        list?.is_failed === true
                          ? "Extraction Failed"
                          : `Progress: ${list?.completion_status}`
                      }
                    >
                      <Box
                        sx={{
                          position: "relative",
                          display: "inline-flex",
                          paddingLeft: "20px",
                        }}
                      >
                        {list?.completion_status === "100%" ? (
                          <DoneAllIcon color="primary" />
                        ) : list?.is_failed === true ? (
                          <RunningWithErrorsIcon />
                        ) : (
                          <CircularProgressWithLabel
                            value={list?.completion_status}
                          />
                        )}
                      </Box>
                    </Tooltip>
                  </TableCell>
                </>
              )}
              {localStorage.getItem("userRole") === "validator" && (
                <>
                  <TableCell> {list?.batch_validation_end_date}</TableCell>

                  {(list?.rejected_by_administrator ||
                    list?.entireBatchRejectedByInvestigatorValidator === true ||
                    list?.validation_review_status === "rejected") && (
                    <TableCell>
                      {" "}
                      <Tooltip
                        title={`Rejection Remark: ${
                          list?.rejected_by_administrator &&
                          list?.administrator_rejection_remark
                            ? list.administrator_rejection_remark
                            : list?.validation_review_status === "rejected" &&
                                list?.validation_reviewer_remark
                              ? list.validation_reviewer_remark
                              : "Rejected"
                        }`}
                      >
                        <PriorityHighIcon color="warning" />
                      </Tooltip>
                    </TableCell>
                  )}

                  {list?.rejected_by_administrator === false &&
                    list?.validation_review_status !== "rejected" && (
                      <TableCell>
                        {list?.validation_completed === true ? (
                          <Tooltip title="Completed">
                            <DoneAllIcon color="primary" />
                          </Tooltip>
                        ) : (
                          <Tooltip title="[Draft]">
                            <img
                              className="img"
                              src={DraftIcon}
                              alt="Draft Icon"
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                    )}

                  <TableCell> {list?.validation_reviewer_name}</TableCell>
                </>
              )}

              <TableCell>
                {moment(list?.updated_on).format("DD-MMM-YYYY")}
                <br />
                {moment(list?.updated_on).format("hh:mm:ss A")}
              </TableCell>
              <TableCell>
                {" "}
                {localStorage.getItem("userRole") === "pre-processor" && (
                  <IconButton
                    disabled={
                      list?.is_ocr_done === "pending" &&
                      list?.is_failed === false
                    }
                    // disabled={
                    //   list?.is_processor_assigned === true ||
                    //   (list?.is_ocr_done === "pending" &&
                    //     list?.is_failed === false) ||
                    //   list?.rejected_by_processor === true
                    // }
                    aria-label="more"
                    onClick={(e) => handleClickOption(e, list, listindex)}
                    aria-haspopup="true"
                    aria-controls="long-menu"
                  >
                    {
                      // list?.is_processor_assigned !== true &&
                      (list?.is_ocr_done !== "pending" ||
                        list?.is_failed === true) && (
                        // list?.rejected_by_processor == true &&
                        <MoreVertIcon
                          onClick={() =>
                            list?.is_ocr_done === "not_started" ||
                            list?.is_ocr_done === "done"
                              ? handleData()
                              : ""
                          }
                        />
                      )
                    }
                  </IconButton>
                )}
                {localStorage.getItem("userRole") === "processor" && (
                  <IconButton
                    disabled={
                      isDisabledEditIcon(list)
                      // list?.is_validator_assigned === true ||
                      // // Second condition with multiple subconditions:
                      // (row?.project_type === "free_form" &&
                      //   ((list?.is_data_entered === true &&
                      //     list?.rejected_by_administrator !== true) || // Disable if data is entered and not rejected
                      //     (list?.rejected_by_administrator === undefined &&
                      //       list?.is_data_entered === true))) || // Disable if data is entered and rejected key is not present
                      // (row?.project_type === "both" &&
                      //   list?.batch_for_qc === true &&
                      //   ((list?.is_data_entered === true &&
                      //     list?.rejected_by_administrator !== true) || // Disable if data is entered and not rejected
                      //     (list?.rejected_by_administrator === undefined &&
                      //       list?.is_data_entered === true)))
                    }
                    aria-label="more"
                    onClick={(e) => {
                      handleClickOption(e, list, listindex);
                    }}
                    aria-haspopup="true"
                    aria-controls="long-menu"
                  >
                    {((list?.batch_for_qc === false &&
                      list?.is_validator_assigned === false) ||
                      (list?.batch_for_qc === true &&
                        list?.validation_skipped === false &&
                        list?.is_validator_assigned === false)) && (
                      <MoreVertIcon
                        onClick={() =>
                          list?.is_validator_assigned !== true ||
                          (row?.project_type === "free_form" &&
                            list?.is_data_entered)
                            ? handleData()
                            : ""
                        }
                      />
                    )}
                  </IconButton>
                )}
                {localStorage.getItem("userRole") === "validator" && (
                  <IconButton
                    disabled={
                      list?.rejected_by_administrator === false &&
                      list?.validation_completed === true &&
                      (list?.validation_review_status === "approved" ||
                        list?.validation_review_status === "assigned")
                      //   ||
                      // list?.batch_for_qc === true
                    }
                    aria-label="more"
                    onClick={(e) => handleClickOption(e, list, listindex)}
                    aria-haspopup="true"
                    aria-controls="long-menu"
                    Menu
                  >
                    {(list?.validation_completed === false ||
                      list?.rejected_by_administrator === true ||
                      list?.validation_review_status === "rejected" ||
                      list?.validation_review_status === "draft") && (
                      <MoreVertIcon onClick={() => handleData()} />
                    )}
                  </IconButton>
                )}
                <Menu
                  anchorEl={anchorE2}
                  onClose={() => handleClosePopUp(listindex)}
                  open={openpop && menus2[listindex] === true}
                >
                  {MyOptions.filter((option) => {
                    // Replace 'processor' and 'validator' with your actual user roles

                    if (
                      localStorage.getItem("userRole") === "pre-processor" &&
                      list?.rejected_by_processor === true &&
                      option === "Edit"
                    ) {
                      return true;
                    } else if (
                      localStorage.getItem("userRole") === "pre-processor" &&
                      list?.rejected_by_processor === false &&
                      option === "View"
                    ) {
                      return true;
                    } else if (
                      localStorage.getItem("userRole") === "pre-processor" &&
                      list?.total_pdfs > 0 &&
                      list?.is_failed === false &&
                      list?.ocr_re_initiate === false &&
                      list?.is_processor_assigned === false &&
                      // list?.ocr_re_initiate === true && // temo for testing
                      option === "Assign Processor"
                    ) {
                      return true;
                    }

                    if (
                      localStorage.getItem("userRole") === "pre-processor" &&
                      list?.total_pdfs > 0 &&
                      list?.is_failed === false &&
                      list?.ocr_re_initiate === true &&
                      list?.rejected_by_processor === false &&
                      option === "Reinitiate auto extraction"
                    ) {
                      return true;
                    } else if (
                      localStorage.getItem("userRole") === "pre-processor" &&
                      list?.is_failed === true &&
                      option === "Reinitiate auto extraction"
                    ) {
                      return true;
                    } else if (
                      localStorage.getItem("userRole") === "pre-processor" &&
                      list?.total_pdfs === 0 &&
                      option === "Upload PDF"
                    ) {
                      return true;
                    } else if (
                      localStorage.getItem("userRole") === "processor" &&
                      option === "Extract"
                    ) {
                      return true;
                    } else if (
                      localStorage.getItem("userRole") === "validator" &&
                      option === "Validate"
                    ) {
                      return true;
                    }
                    return false;
                  }).map((option) => (
                    <MenuItem
                      key={option}
                      onClick={() => {
                        handleClickOnOption(option);
                      }}
                    >
                      {/* {list?.total_pdfs === 0 ? (option === "Upload PDF" ? "Upload PDF" : option) : option} */}

                      {option}
                    </MenuItem>
                  ))}
                </Menu>
              </TableCell>
            </TableRow>
          </React.Fragment>
        ))}

      {clone && (
        <CloneModal open={clone} onCloseClone={onCloseClone}></CloneModal>
      )}
      {infoModal && (
        <InfoModal
          isOpen={infoModal}
          handleClose={() => setInfoModal(false)}
          infoData={infoData}
        ></InfoModal>
      )}
    </>
  );
}

export default function DashboardTable(props) {
  const { header, projects } = props;
  return (
    <>
      <Box className="dashboard-wrap">
        <TableContainer className="dashBoardTh">
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell> </TableCell>
                {header?.map((list, index) => {
                  return (
                    <TableCell key={index} className="table-header-title">
                      {list}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody
            // className="tBody"
            >
              {projects &&
                projects?.length > 0 &&
                projects?.map((project, i) => (
                  <Row
                    key={project?.project_id}
                    row={project}
                    i={i}
                    props={props}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}
